// extracted by mini-css-extract-plugin
export default {"checkbox":"YcKrmv","changeButton":"I5WXIi","modal":"ukloLx","description":"cQm_ug","citySelect":"hr_8Oa","submit":"I2JgUd"};